import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSession } from '../../../../../models/users/user-session.model';
import { UserSessionsResultsResponse } from '../../../../../models/users/responses/api-users-sessions-results-response.model';
import { ApiUsersService } from '../../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { DateService } from '../../../../../services/date.service';

@Component({
  selector: 'app-user-sessions-tab',
  templateUrl: './user-sessions-tab.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class UserSessionsTabComponent {

  @Input() userId: number = 0;

  isLoading: boolean = false;

  expandedTokens = new Set<number>();
  toggleToken(index: number): void { this.expandedTokens.has(index) ? this.expandedTokens.delete(index) : this.expandedTokens.add(index); }

  sessions: UserSession[] = [];
  resultsPerPage: number = 25;
  pageNumber: number = 1;
  totalResults: number = 0;

  get totalPages(): number {
    return Math.ceil(this.totalResults / this.resultsPerPage);
  }

  getPageNumbers(): (number | null)[] {
    const total = this.totalPages;
    const current = this.pageNumber;

    const visibleSet = new Set<number>();
    for (let i = 1; i <= Math.min(2, total); i++) visibleSet.add(i);
    for (let i = Math.max(total - 1, 1); i <= total; i++) visibleSet.add(i);
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) visibleSet.add(i);

    const sorted = Array.from(visibleSet).sort((a, b) => a - b);

    const result: (number | null)[] = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push(null);
      result.push(sorted[i]);
    }

    return result;
  }

  goToPage(page: number): void {
    this.pageNumber = page;
    this.refreshSessionsList();
  }

  constructor(public dateService: DateService, private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  load(): void {
    this.pageNumber = 1;
    this.refreshSessionsList();
  }

  onClickPaginationPrevious(): void {
    this.pageNumber--;
    this.refreshSessionsList();
  }

  onClickPaginationNext(): void {
    this.pageNumber++;
    this.refreshSessionsList();
  }

  private refreshSessionsList(): void {
    this.isLoading = true;

    this.apiUsersService.getUserSessions(this.userId, this.pageNumber, this.resultsPerPage).then(
      (response: UserSessionsResultsResponse) => {
        this.isLoading = false;
        this.sessions = response.results;
        this.totalResults = response.resultsTotal;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading sessions (' + error + ')');
      }
    );
  }
}
